<template>
    <project-step-container
            prev-to="be_go_broad_to_go_narrow_15"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0" >
                {{getMessage(16, 'gobroadtogonarrow-sub')}}
            </b-col>
        </b-row>

        <upload-image :project-id="projectId" :step="step"/>
    </project-step-container>
</template>

<script>
    import Steps from "../Utils/steps";
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import UploadImage from "../../../core/Components/UploadImage"

    export default {
        name: "GoBroadToGoNarrow16",
        components: {ProjectStepContainer, UploadImage},
        data() {
            return {
                step: Steps.FORM_SKETCH,
                projectId: Storage.getProjectId(this.$route.params.index),
                urlNextProject:'be_rapid_experiments_with_customers_17',
                form: {
                    sketch: "",
                },
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>
